import classnames from 'classnames';
import { addMonths, getMonth, startOfYear } from 'date-fns';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../theme';
import { isMonthAvailable } from '../../../../utils';
import { RendererFunctionInterface, RendererFunctionsContext } from '../../../Datepicker';
import { Dropdown, DropdownElement } from '../../../Dropdown/Dropdown';

export interface Props {
	setCurrentMonth: (timestamp: number, monthOffset: number) => void;
	minDate: Date;
	maxDate: Date;
	monthIndex: number;
	currentDate: Date;
	years: Date[];
}

export const MonthHeader: React.FunctionComponent<Props> = props => {
	const { t } = useTranslation('Datepicker');
	let selectedYear = 0,
		selectedMonth = 0;

	const monthHeaderAsPlainText = React.useContext<RendererFunctionInterface>(RendererFunctionsContext)
		.monthHeaderAsPlainText;

	const elements: DropdownElement[] = [],
		month = getMonth(props.currentDate),
		year = !monthHeaderAsPlainText
			? props.years.map(year => {
					if (year.getFullYear() === props.currentDate.getFullYear()) {
						selectedYear = year.getTime();
					}

					return {
						id: year.getTime(),
						text: year.getFullYear().toString(),
						isActive: true
					};
			  })
			: [];

	if (!monthHeaderAsPlainText) {
		let initialDate = startOfYear(props.currentDate);

		for (let i = 0; i < 12; i++) {
			elements.push({
				id: initialDate.getTime(),
				isActive: isMonthAvailable(initialDate, 0, props.minDate, props.maxDate),
				text: t(`month_${i}`)
			});

			if (month === i) {
				selectedMonth = initialDate.getTime();
			}

			initialDate = addMonths(initialDate, 1);
		}
	}

	const theme = useTheme('Datepicker').MonthHeaderStyles;

	return (
		<div className={theme.monthHeader}>
			<Dropdown
				elements={elements}
				className={classnames(theme.monthHeader__select, theme.monthHeader__select_month, {
					[theme.monthHeader__select_asPlainText]: monthHeaderAsPlainText
				})}
				value={selectedMonth}
				onClick={(id: number) => {
					props.setCurrentMonth(id, 0 - props.monthIndex);
				}}
				asPlainText={monthHeaderAsPlainText}
			>
				{t(`month_${month}`)}
			</Dropdown>

			<Dropdown
				elements={year}
				value={selectedYear}
				onClick={(id: number) => {
					props.setCurrentMonth(id, 0 - props.monthIndex);
				}}
				className={classnames(theme.monthHeader__select, theme.monthHeader__select_year, {
					[theme.monthHeader__select_asPlainText]: monthHeaderAsPlainText
				})}
				asPlainText={monthHeaderAsPlainText}
			>
				{props.currentDate.getFullYear()}
			</Dropdown>
		</div>
	);
};
